<template>
  <div ref="watermark" class="cont">

    <div style="color:#999999;margin:29px 0;display:flex;justify-content:center">
      <div>我的购物车</div>
      <div style="text-align:right;flex:1">
        <span style="margin-right:10px;font-size: 14px;color: #333333;">价格开关</span>
        <el-switch v-model="priceShow" @change="togglePriceShow"> </el-switch>
      </div>
    </div>

    <el-table
      ref="multipleTable"
      :data="cartItemlist"
      tooltip-effect="dark"
      @row-click='gotoDetail'
      style="width: 100% ; border:1px solid #e4e4e4;min-height:400px"
      :row-style="{height: '100px'}"
      @selection-change="handleSelectionChange"
      :header-cell-style="{background:'#f9f9f9' , height : '80px'}"
      id="multipleTable"
    >

      <el-table-column type="selection"  width="55" >
      </el-table-column>

      <el-table-column label="商品信息"  align="center"  width="450" >
        <template slot-scope="scope">
          <div style="display:flex;" >
            <div>
              <el-image
                style="width: 100px; height: 100px;display: block"
                :src=" publicUrl  + scope.row.goodsPic "
                fit="contain" >
              </el-image>

              <el-image v-if="scope.row.promotionStatus ==1"
                        style="width: 100px; height: 20px" :src=" publicUrl + '/profile/avatar/cxz.png' " fit="contain">
              </el-image>
            </div>

            <div style="flex:1;margin-left:15px;/*display:flex;*/flex-direction:column;justify-content:center;align-items:flex-start">
              <div v-if="moduleUser.goods_visible == '1' ">
                {{ scope.row.goodsName }}
              </div>
              <div v-else-if="moduleUser.goods_visible == '0' ">
                {{ scope.row.specification ?  scope.row.specification : ''}}
              </div>

              <div style="color:#999999;font-size: 12px;text-align: left;"> {{ scope.row.searchValue?'适配：'+scope.row.searchValue:'' }} </div>
              <div style="color:#999999;font-size: 12px;text-align: left;"> {{ scope.row.vin?'车架号：'+scope.row.vin:'' }} </div>
            </div>
          </div>
        </template>
      </el-table-column>

      <el-table-column  prop="price"  label="单价"  width="250">
        <template slot-scope="scope">
          <div style="display:flex;">
            <div style="color: #7F7F7F;">
              <div>零售价</div>
              <div>{{ scope.row.goodsPrice  ? '¥' + scope.row.goodsPrice  : ''  }}</div>
            </div>
            <div style="color: #E60012;margin-left:20px" v-show="priceShow&&scope.row.promotionStatus ==1">
              <div style="text-decoration: line-through;">拿货价</div>
              <div style="text-decoration: line-through;">{{ scope.row.discountPrice  ? '¥' + scope.row.discountPrice  : '已失效'  }}</div>
            </div>
            <div style="color: #E60012;margin-left:20px" v-show="priceShow&&scope.row.promotionStatus ==1">
              <div>活动价</div>
              <div>{{ scope.row.discountPrice  ? '¥' + scope.row.promotionPrice  : '已失效'  }}</div>
            </div>

            <div style="color: #E60012;margin-left:20px" v-show="priceShow&&scope.row.promotionStatus !=1">
              <div>拿货价</div>
              <div>{{ scope.row.discountPrice  ? '¥' + scope.row.discountPrice  : '已失效'  }}</div>
            </div>
          </div>
          <div>
            <div class='line line2'  @click.stop="goodsStockDetail(scope.row)" style="color: red">查看库存详情>></div>
          </div>
        </template>
      </el-table-column>

      <el-table-column label="数量" align="center" >
        <template slot-scope="scope"  >
          <div @click.stop="stopPop">
            <el-input-number
              v-model="scope.row.quantity"
              @change="handleChange( scope )"
              :min="1"
              size="small"
              label="描述文字"></el-input-number>
          </div>

          <div style="margin-top:13px">
            <div v-if="moduleUser.inventory_visible == '1' ">
              库存数: {{ scope.row.amount }}
            </div>

            <div v-if=' moduleUser.inventory_visible == "0" ' >
              <!-- <el-image
                style="width: 115px; height: 31px;"
                :src=' publicUrl + "/profile/avatar/现货充足.png" '
                fit="contain"
                v-if=' scope.row.amount > moduleUser.goods_num '
              ></el-image> -->
              <!-- <el-image
                style="width: 115px; height: 31px;"
                :src=' publicUrl + "/profile/avatar/少量现货.png" '
                fit="contain"
                v-else-if=' scope.row.amount <= moduleUser.goods_num  && scope.row.amount > 0 '
              ></el-image>
              <el-image
                style="width: 115px; height: 31px;"
                :src=' publicUrl + "/profile/avatar/即将到货.png" '
                fit="contain"
                v-else-if=' scope.row.amount == 0  '
              ></el-image> -->
              <div v-if=' scope.row.amount > moduleUser.goods_num' style="font-size: 16px;font-weight: 700;color: #D10217;">现货充足</div>
              <div v-else-if=' scope.row.amount <= moduleUser.goods_num  && scope.row.amount > 0'  style="font-size: 16px;font-weight: 700;color: #000;">少量现货</div>
              <div v-else-if=' scope.row.amount == 0'  style="font-size: 16px;font-weight: 700;color: #A8ADAF;">可以预定</div>
            </div>

          </div>
        </template>
      </el-table-column>

      <el-table-column label="小计"  width="120">
        <template slot-scope="scope">
          <div style="color:red" v-if="scope.row.promotionStatus ==1"> {{ '¥' + (scope.row.promotionPrice * scope.row.quantity).toFixed(2) }} </div>
          <div style="color:red" v-if="scope.row.promotionStatus !=1"> {{ '¥' + (scope.row.discountPrice * scope.row.quantity).toFixed(2) }} </div>
        </template>
      </el-table-column>

      <el-table-column label="操作" width="120">
        <template slot-scope="scope">
          <el-button
            style="color:#666666"
            type="text"
            size="mini"
            @click.stop="slideButtonTap(scope.$index, scope.row)">删除</el-button>
        </template>
      </el-table-column>

    </el-table>

    <div style="background-color:#fff;margin-top:44px;margin-bottom:21px;display:flex;height:80px">
      <div style="flex:1;display:flex;align-items:center">
        <el-checkbox
        @change="toggleSelection(  cartItemlist  )"
        style="margin-right:19px;margin-left:15px"
        v-model="checked">全选
      </el-checkbox>
      <el-button type="text" style="color:#666666" @click="deleteItems">删除选中商品</el-button>
      <div style="flex:1;text-align:right;line-height:80px;margin-right:20px;font-size:14px;color:#999999">共 <span style="color:red">{{ cartItemlist.length }}</span> 件商品，已选择 <span style="color:red"> {{ multipleSelection.length }}</span>  件  |
        <!-- 商品合计 : ¥{{ totalGoodPrice }}    -->
        零售价: ¥{{ totalGoodPrice }}
        <span v-show="priceShow">拿货价: ¥{{ totalPrice }}</span>
        <span v-show="priceShow&&promotionStatus==1"> 活动价: ¥{{ totalPromotionPrice }}</span>
        |  应付总额：
        <span :style="{color:'red',fontSize:totalPrice>100000?'22px':'24px'}" v-show="promotionStatus!=1">¥{{ totalPrice }}</span>
        <span :style="{color:'red',fontSize:totalPromotionPrice>100000?'22px':'24px'}" v-show="promotionStatus==1">¥{{ totalPromotionPrice }}</span>

      </div>
      </div>
      <div type="danger"
        style="height:80px;width:234px;line-height:80px;text-align:center;color:#fff;font-weight:700;font-size:18px;cursor : pointer"
        :style="{backgroundImage: 'url(' + btn_red + ')' }"
        @click="gotoSettlement"
      >

        下单结算
      </div>
    </div>


    <el-dialog title="" :visible.sync="showFlag" width="650px" center  :show-close='false'
               :close-on-press-escape='false' :close-on-click-modal ='false' >
      <div style="width:100%;margin-bottom:10px;text-align: center">
        <div style="text-align: center;font-size: 20px;font-weight: bold;margin-bottom: 60px">{{goodsName}}</div>
        <div style="margin-bottom: 100px">
          <div v-for=" ( detail , idx ) in stockDetail " :key='idx' style="text-align: center;  width: 100%;   margin-left: 33%;margin-bottom: 20px">
              <div  class="background_style btn"  :style="{backgroundImage: 'url(' + u35 + ')' }" style="text-align: center;width: 200px" >
                <div v-if='detail.showFlag == "0"'>
                  {{detail.subWarehouseName}} :
                  <span  v-if='detail.quantity > moduleUser.goods_num'>现货充足</span>
                  <span  v-else-if='detail.quantity <= moduleUser.goods_num && detail.quantity > 0' >少量现货</span>
                  <span v-else-if= 'detail.quantity == 0'  >可以预定</span>
                </div>
                <div v-else-if='detail.showFlag == "1"'>
                  {{detail.subWarehouseName}} :
                  <span  v-if='detail.quantity > moduleUser.goods_num'>现货充足</span>
                  <span  v-else>{{  detail.quantity }}</span>
                </div>
              </div>
          </div>
          <div   style="text-align: center;  width: 100%;   margin-left: 33%;margin-bottom: 20px">
            <div   class="background_style btn"  :style="{backgroundImage: 'url(' + u35 + ')' }" style="text-align: center;width: 200px" >
              在途数 :{{transitQuantity}}
            </div>
          </div>
        </div>
      </div>
      <div style="display:flex;justify-content:center">
        <div class="background_style btn"  :style="{backgroundImage: 'url(' + btn_red + ')' }"
             style="cursor : pointer"  @click="stockDetailCancel" >
          关闭
        </div>
      </div>
    </el-dialog>

  </div>
</template>

<script>
  import { getCartItemlistReq , delCartItemReq ,  updageCartItemReq,getCheckPayCnt   } from "@/api/shoppingCart/index";
  import { getStockDetail } from "@/api/productList/productList";
  import watermark from '@/utils/waterMark'
  export default {
    comments:watermark,
    data() {
      return {
        showFlag : false ,
        stockDetail:[],
        goodsName:'',
        transitQuantity:0,
        priceShow : true ,
        checked : false , //是否全选
        cartItemlist: [],
        multipleSelection: [] ,
        publicUrl : this.common.publicUrl ,
        totalPrice : 0 , //总价
        promotionStatus : 0 , //促销状态
        totalPromotionPrice : 0 , //促销总价
        totalGoodPrice : 0 , //总原价
        btn_red : this.common.publicUrl + '/profile/avatar/u1363.png' ,
        u35 : this.common.publicUrl + '/profile/avatar/u35.png' ,
      }
    },
    mounted(){
      this.$nextTick(()=>{
        let  dealerName =window.localStorage.dealerName
        let  username =window.localStorage.username
        let text =dealerName+username.substring(username.length-4,username.length)
        watermark.set(text,this.$refs.watermark);
      })
    },
    methods: {
      togglePriceShow(){
        window.localStorage["priceShow"] =this.priceShow?"0":"1";
      },
      //手动切换全选事件
      toggleSelection(rows) {
        // console.log( this.checked )
        if ( this.checked ) {
          rows.forEach(row => {
            this.$refs.multipleTable.toggleRowSelection(row  , true );
          });
        } else {
          this.$refs.multipleTable.clearSelection();
        }
        this.calcTotalPrice()

      },
      stockDetailCancel(){
        this.showFlag = false;
      },
      // 库存详情
      goodsStockDetail( goodItem ){
        console.log(goodItem)
        let item = goodItem
        this.goodsName =item.goodsName
        this.stockDetail= [];
        getStockDetail({
          jancode:item.jancode ,
        }).then( res => {
          if (res.data.status == 0) {
            this.showFlag = true;
            this.stockDetail = res.data.stockDetail;
            this.transitQuantity = res.data.transitQuantity;
          } else {
            this.$message.error(res.data.statusDesc);

          }
        })

      },
      // 切换选中事件
      handleSelectionChange(val) {
        this.multipleSelection = val;

        // console.log( val.length )
        // console.log( this.cartItemlist.length )
        // console.log(  val.length == this.cartItemlist.length  )
        if( val.length == this.cartItemlist.length && this.cartItemlist.length > 0 ){
          this.checked = true
        }else{
          this.checked = false
        }
        this.calcTotalPrice()
      },
      //改变数量事件
      handleChange(row) {

        // console.log(value);
        this.updageCartItem( row.row.cartId , row.row.quantity )
        this.calcTotalPrice()
      },
      //删除单个产品
      slideButtonTap( index  ){
        let cartIds = this.cartItemlist[index].cartId ;
        let cartItemlist = this.cartItemlist ;
        delCartItemReq({
          cartIds : cartIds
        }).then( res => {
          if (res.data.status == 0) {
            cartItemlist.splice( index , 1 )
            this.cartItemlist = cartItemlist
            this.calcTotalPrice()
          } else {
            this.$message.error(res.data.statusDesc);
          }
        } )
      },
      //删除多个产品
      deleteItems(){
        let itemsArr = []
        let itemsStr = ''
        this.multipleSelection.forEach( (val ) => {
          itemsArr.push( val.cartId )
        })
        itemsStr = itemsArr.join( ',' )
        delCartItemReq({
          cartIds : itemsStr
        }).then( res => {
          if (res.data.status == 0) {
            this.getCartItemlist()
            this.checked = false
          } else {
            this.$message.error(res.data.statusDesc);
          }
        })

      },

      //购物车列表
      getCartItemlist(){
        getCartItemlistReq().then( res => {
          if (res.data.status == 0) {
            // console.log( res.data )
            let cartItems = res.data.cartItems ;
            this.cartItemlist = cartItems
            this.calcTotalPrice()
            // that.calcTotalPrice()
          } else {
            this.$message.error(res.data.statusDesc);
          }
        })
      },
      //更新购物车商品数量
      updageCartItem( cartIds , quantity ){
        updageCartItemReq({
          cartIds : cartIds ,
          quantity :  quantity ,
        }).then( res => {
          if( res.data.status == 0  ){
            this.$store.commit('cart_refresh_open');
          }
        })
      },
      //计算所有价格
      calcTotalPrice(){
        let multipleSelection = this.multipleSelection ;
        // console.log( multipleSelection  )

        let totalPrice = 0 ;
        let totalPromotionPrice = 0 ;
        let totalGoodPrice = 0 ;
        let flag =false;
        multipleSelection.forEach( (val  ) => {
          // console.log( val )
          if(  val.discountPrice ){
            if(val.promotionStatus==1){
              flag =true;
              totalPromotionPrice += val.quantity * val.promotionPrice
            }else{
              totalPromotionPrice += val.quantity * val.discountPrice
            }

            totalPrice += val.quantity * val.discountPrice
            totalGoodPrice += val.quantity * val.goodsPrice
          }
        })
        if(flag){
          this.promotionStatus=1
        }else{
          this.promotionStatus=0
        }
        this.totalPromotionPrice = totalPromotionPrice.toFixed(2)
        this.totalPrice = totalPrice.toFixed(2)
        this.totalGoodPrice = totalGoodPrice.toFixed(2)
      } ,
      //去结算
      gotoSettlement(){
        let cartItemlist = this.multipleSelection ;
        let apiTempOrder = [] ;
        cartItemlist.forEach( ( val  ) => {
          if( val.discountPrice ){
            apiTempOrder.push( {
              goodsId : val.goodsId ,
              jancode : val.jancode ,
              quantity : val.quantity,
            } )
          }
        });
        if( apiTempOrder.length <= 0 ){
          this.$message.error('没有选择商品');
          return
        }
        apiTempOrder =  JSON.stringify( apiTempOrder )
        this.getCheckPay(apiTempOrder);



      },
      getCheckPay(apiTempOrder){
        let that =this;
        getCheckPayCnt().then( res => {
            if( res.data.status == 0  ){
              if( res.data.row == 0  ){
                that.$router.push({
                  path: '/splitOrder',
                  query: {
                    apiTempOrder : apiTempOrder ,
                    isCartItem : 1 ,
                  }
                })
              }else{
                that.$confirm('您有订单未支付,请先去支付', '提示', {
                  confirmButtonText: '确定',
                  cancelButtonText: '取消',
                  type: 'warning'
                }).then(() => {
                  that.$router.replace({path: '/user/order'})
                }).catch(() => {

                });
              }
            }
          })
      },
      //前往产品详情
      gotoDetail(item){
        let goodsId = item.goodsId
        let jancode = item.jancode
        this.$router.push({
          path: '/goodDetail',
          query: {
            goodsId: goodsId ,
            jancode : jancode
          }
        })
      },
      //阻止冒泡
      stopPop(){

      }
    } ,
    computed : {
      moduleUser() {
        return this.$store.state.moduleUser; // 这里返回的是：{name: 'wang', age: 22}
      }
    },
    created(){
      this.getCartItemlist();

      this.$nextTick(()=>{
        console.log(window.localStorage.priceShow==0?true:false)
        this.priceShow = window.localStorage.priceShow==0?true:false;
      })
    }
  }
</script>

<style lang="stylus" scoped>
.cont {
  width: 1200px;
  color: #000;
  margin: 0 auto;
  box-sizing: border-box;
}

.el-header {
  background-color: #B3C0D1;
  color: #333;
  line-height: 60px;
}

.el-aside {
  color: #333;
}


.cont >>> .el-table--enable-row-hover .el-table__row:hover{
  cursor : pointer
}
.cont >>>  .el-checkbox__inner {
  width : 20px
  height : 20px
  border: 1px solid #f90000;
}
.cont >>>  .el-checkbox__inner::after {
  left 7px
  top 4px
}

</style>
